<template>
	<div class="service">
		<XStateHeader />
		<XHeaderNav hide-search hide-back />
		<ServiceHeader v-model:value="filter" />
		<ServiceGroup :filter="filter" />
	</div>
</template>
<script setup lang="ts">
import XStateHeader from '@/components/XStateHeader.vue'
import ServiceHeader from '@/views/pages/service/components/ServiceHeader.vue'
import ServiceGroup from '@/views/pages/service/components/ServiceGroup.vue'
import XHeaderNav from '@/components/XHeaderNav.vue'

const filter = ref({
	type: 0,
	keyWords: null,
	cateStrList: [],
	filter2: null
})
const route = useRoute()

onActivated(() => {
	if (route.query.type) {
		filter.value.type = Number(route.query.type)
	}
})
</script>

<style scoped lang="scss">
.service {
}
</style>
